import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFarmFootprintByYear } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_FARM } from "consts";

export const useGetFootprintingFarmFootprint = (farmId?: string, year?: number, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const enableQuery = (enabled && !!farmId && !!year && !!user && carbonProgram?.platformFeatures?.footprinting?.enabled && !!token) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_FARM, farmId, year, isAdmin],
      queryFn: async () => getFarmFootprintByYear(farmId ?? "", year ?? 0),
      enabled: enableQuery,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
